<template>
  <div v-if="isShown">
    <!-- EXPANDED -->
    <v-slide-y-transition hide-on-leave>
      <div v-show="isOpen">
        <!-- ONLY DESKTOP -->
        <div
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <!-- HIDE QUOTE -->
          <v-btn
            v-ripple="false"
            small
            color="white"
            class="elevation-1 remove-bottom-radius mx-4"
            @click="$emit('toggle-quote-shown', quote.id)"
          >
            <v-icon
              color="primary"
              :size="16"
              class="mr-1 mb-2px"
            >
              mdi-minus-circle-outline
            </v-icon>
            <span class="primary--text caption">
              Hide quote
            </span>
          </v-btn>
        </div>

        <v-card :class="{ 'offer-border': hasSpecialOffer }">
          <v-container
            fluid
            class="overflow-x-auto overflow-y-hidden"
          >
            <slot
              name="desktop-quote"
            />
            <slot
              name="mobile-quote"
            />
          </v-container>
          <div class="caption">
            <div class="px-2">
              <slot name="caption" />
            </div>

            <div
              v-if="hasSpecialOffer"
              class="accent-gradient offer-gap py-2 px-3"
            >
              <v-icon
                small
                color="navy-dark"
                class="mr-2"
              >
                mdi-tag
              </v-icon>
              <span v-html="details.companyConfig.featuredText" />
            </div>
            <div
              v-else-if="hasInfoText"
              class="offer-gap py-2 px-3"
            >
              <v-icon
                small
                color="navy-dark"
                class="mr-2"
              >
                mdi-tag
              </v-icon>
              <span v-html="details.specialOffer" />
            </div>
          </div>
        </v-card>
      </div>
    </v-slide-y-transition>

    <!-- COLLAPSED -->
    <v-slide-y-reverse-transition hide-on-leave>
      <v-card
        v-show="!isOpen"
        class="card"
      >
        <v-container fluid>
          <div class="d-flex align-items-center">
            <v-btn
              v-ripple="false"
              small
              color="white"
              depressed
              @click="$emit('toggle-quote-shown', quote.id)"
            >
              <v-icon
                color="primary"
                :size="16"
                class="mr-1 mb-2px"
              >
                mdi-plus-circle-outline
              </v-icon>
              <span class="primary--text caption">
                Show hidden quote
              </span>
            </v-btn>

            <img
              :src="details.imageSiteRemote"
              :alt="details.brokerFullName"
              class="hidden-quote-img px-4 mx-3"
            >

            <span class="title">
              <!-- eslint-disable-next-line max-len -->
              &pound;{{ calcAnnualWholeNumber }}<span class="subtitle-2">.{{ calcAnnualFractionalPart }}</span>
              <span class="caption ml-2 mb-0">per year</span>
            </span>
          </div>
        </v-container>
      </v-card>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
export default {
  name: 'quote-wrapper',
  props: {
    quote: {
      type: Object,
      required: true,
    },
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {
    calcAnnualWholeNumber () {
      return this.details.calcAnnual.toString().split('.')[0];
    },
    calcAnnualFractionalPart () {
      return this.details.calcAnnual.toString().split('.')[1];
    },
    isShown () {
      return this.quote && Object.keys(this.quote).length;
    },
    isOpen () {
      return this.quote.shown;
    },
    hasSpecialOffer () {
      // proper special offers are listed in companyConfig / featuredText
      return !!this.details.companyConfig && Object.keys(this.details.companyConfig).length;
    },
    hasInfoText () {
      // general info text (in json response as specialOffer)
      return !!this.details.specialOffer && this.details.specialOffer.length;
    },
  },
};
</script>

<style scoped lang="scss">
.offer-border {
  border: 2px solid var(--v-primary-base, $clr-primary);
}

.accent-gradient {
  background: linear-gradient(180deg, $clr-seopa-light-yellow, $clr-seopa-yellow);
}

.offer-gap {
  margin-right: 0.5px;
}

.hidden-quote-img {
  height: 28px;
  border-left: 1px solid $clr-heather;
  border-right: 1px solid $clr-heather;
}
</style>
